import React, { FC, useState } from 'react';
import { 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { ApplicationDocuments } from './ApplicationDocuments';
import { IApplicationDocument } from '../Interfaces/Application/IApplicationDocument';

export interface ApplicationDocumentsViewerProps {
  applicationDocuments: IApplicationDocument[];
}

export const ApplicationDocumentsViewer: FC<ApplicationDocumentsViewerProps> = props => {

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <>
    {(props.applicationDocuments?.length > 0) &&
    <Button onClick={handleOpen} color="primary" variant="text">
      {props.applicationDocuments?.length || 0}
    </Button>
    }
    <Dialog
      fullWidth
      maxWidth="xl"
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          height: '100%',
        }
      }}
    >
      <DialogTitle>Text Message Attachments</DialogTitle>
      <DialogContent>
        <ApplicationDocuments
          applicationId=""
          documents={props.applicationDocuments}
          style={{
            height: '100%',
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
    </>
  );
}
